import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static values = { variantSku: String }
  static targets = [
    'productName',
    'brandName',
    'variantSku',
  ]

  productChanged(e) {
    this.productNameTarget.textContent = e.target.value
  }

  brandChanged(e) {
    const selectedText = e.target.options[e.target.selectedIndex].text
    this.brandNameTarget.textContent = selectedText
  }

  variantChanged(e) {
    let sku = ''
    if (e.target.value) {
      const selectedText = e.target.options[e.target.selectedIndex].text
      sku = selectedText.split(' - ').pop().replace(/[()]/g, '').trim()
    } else {
      sku = this.variantSkuValue
    }
    this.variantSkuTarget.textContent = sku
  }
}
